"use client";

import { useSearchParams } from "next/navigation";

import { BannerWithTitleOnly } from "#app/_ui/components/banners/BannerWithTitleOnly";
import { FactsetDisclaimers } from "#app/_ui/components/market-research/factset-disclaimers";
import { SearchAssetsTable } from "#app/_ui/components/market-research/search-assets-table";
import { useStockLinkClick } from "#app/_ui/components/market-research/use-stock-link-click";
import { Card, CardContent } from "#ui/card";
import { Container } from "#ui/container";
import { Main } from "#ui/main";

export default function StockAssetsTableContent() {
  const stockLinkClick = useStockLinkClick();
  const searchParams = useSearchParams();
  const searchTerm = decodeURIComponent(searchParams.get("searchTerm") ?? "");
  return (
    <Main>
      <BannerWithTitleOnly title="Stocks Search" />
      <Container>
        <div className="space-y-30px">
          <Card variant="white-border">
            <CardContent>
              <SearchAssetsTable
                searchTerm={searchTerm}
                tab={searchParams.get("tab") ?? ""}
                symbolLinkClick={stockLinkClick}
              />
            </CardContent>
          </Card>
          <FactsetDisclaimers />
        </div>
      </Container>
    </Main>
  );
}
